import React, { Component } from 'react';
import { InputText } from 'primereact/inputtext';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { Message } from 'primereact/message';
import { Dialog } from 'primereact/dialog';
import { Growl } from 'primereact/growl';
import { TriStateCheckbox } from 'primereact/tristatecheckbox';
import { CALENDARIO_ES_MX, FORMATO_FECHA_CALENDAR, DEFAULT_MASKS } from '../servicio/ServicioConstantes';
import servicioObjetos from '../servicio/ServicioObjetos';
import servicioHttp from '../servicio/ServicioHttp';
import servicioFormatos from '../servicio/ServicioFormatos';
import servicioArchivos from '../servicio/ServicioArchivos';
import { Checkbox } from 'primereact/checkbox';
import { obtenerInformacionNavegador } from '../servicio/ServicioInformacionNevegador';


const OBJ_HABILITADO = {
    movimiento: false,
    fechaInicio: false,
    sdi: false,
    motivoBaja: false,
    folio: false,
    dias: false,
    articulo33: false,
    salarioOtrosSeguros: false,
    salarioIvCv: false,
    aplicaDescuento: true
}

const OBJETO_ART33 = {
    salarioOtrosSeguros: false,
    movimiento: false,
    fechaInicio: false,
    sdi: false,
    motivoBaja: true,
    folio: true,
    dias: true,
    salarioIvCv: true,
    tipoDescuento: true,
    valorDescuento: true,
    numCredito: true,
    aplicaDescuento: true
}

const OBJ_DESABILITAR_BAJA = {
    movimiento: false,
    fechaInicio: false,
    sdi: true,
    motivoBaja: false,
    folio: true,
    dias: true,
    articulo33: true,
    salarioOtrosSeguros: true,
    salarioIvCv: true,
    tipoDescuento: true,
    valorDescuento: true,
    numCredito: true,
    aplicaDescuento: true
}

const OBJ_DESABILITAR_MODIFICACION = {
    movimiento: false,
    fechaInicio: false,
    sdi: false,
    motivoBaja: true,
    folio: true,
    dias: true,
    salarioOtrosSeguros: true,
    salarioIvCv: true,
    tipoDescuento: true,
    valorDescuento: true,
    numCredito: true,
    aplicaDescuento: true
}
const OBJ_DESABILITAR_AUSENTISMO = {
    movimiento: false,
    fechaInicio: false,
    sdi: true,
    motivoBaja: true,
    folio: true,
    dias: false,
    articulo33: true,
    salarioOtrosSeguros: true,
    salarioIvCv: true,
    tipoDescuento: true,
    valorDescuento: true,
    numCredito: true,
    aplicaDescuento: true,

}

const OBJ_DESABILITAR_REINGRESO = {
    movimiento: false,
    fechaInicio: false,
    sdi: false,
    motivoBaja: true,
    folio: true,
    dias: true,
    articulo33: true,
    salarioOtrosSeguros: true,
    salarioIvCv: true,
    tipoDescuento: true,
    valorDescuento: true,
    numCredito: true,
    aplicaDescuento: true
}

const OBJ_CONTROL_INCAPACIDAD_INICIO = {
    controlIncapacidad: true,
}

const OBJ_CONTROL_INCAPACIDAD = {
    controlIncapacidad: false,
    porcentaje: true,
    fechaFinalIncapacidad: true,
}

//////arreglos para desabiliar cuando se escoge control de incapacidad
const OBJ_CONTROL_ICAPACIDAD_NINGUNO = {
    dias: true,
    folio: true,
    porcentaje: true
}
const OBJ_CONTROL_INCAPACIDAD_1_4 = {
    porcentaje: true
}
const OBJ_CONTROL_INCAPACIDAD_5 = {
    dias: true,
    folio: true,
    porcentaje: false

}
const OBJ_CONTROL_DEFUNCION_6 = {
    folio: true,
    dias: true,
    porcentaje: true
}
const OBJ_CONTROL_7_9 = {
    porcentaje: true,
}
const OBJ_4_LICENCIA_CTRL_NINGUNO = {
    porcentaje: true,
    folio: false,
    dias: false,
    secuelaOconcecuencia: true,
    tipoRiesgo: true
}

const OBJ_CONTROL_ICAPACIDAD_NINGUNO_DES_SECUELA = {
    dias: true,
    folio: true,
    porcentaje: true,
    tipoRiesgo: true,
    secuelaOconcecuencia: true
}
const OBJ_CONTROL_INCAPACIDAD_1_4_DES_SECUELA = {
    porcentaje: true,
    tipoRiesgo: true,
    secuelaOconcecuencia: true
}
const OBJ_CONTROL_INCAPACIDAD_5_DES_SECUELA = {
    dias: true,
    folio: true,
    porcentaje: false,
    tipoRiesgo: true,
    secuelaOconcecuencia: true

}
const OBJ_CONTROL_DEFUNCION_6_DES_SECUELA = {
    folio: true,
    dias: true,
    porcentaje: true,
    tipoRiesgo: true,
    secuelaOconcecuencia: true
}
const OBJ_CONTROL_7_9_DES_SECUELA = {
    porcentaje: true,
    tipoRiesgo: true,
    secuelaOconcecuencia: true
}
///////////////////////////
const OBJ_RAMO_ENFERMEDAD_GENERAL = {
    tipoRiesgo: true,
    secuelaOconcecuencia: true,

}
const OBJ_RAMO_MATERNIDAD = {
    tipoRiesgo: true,
    secuelaOconcecuencia: true,

}

const OBJ_INCAPACIDAD_INICIO = {
    secuelaOconcecuencia: true,
}

const OBJ_DESABILITAR_CREDITO_VIVIENDA = {
    movimiento: false,
    fechaInicio: false,
    sdi: true,
    motivoBaja: true,
    folio: true,
    dias: true,
    articulo33: true,
    salarioOtrosSeguros: true,
    salarioIvCv: true,
    tipoDescuento: false,
    valorDescuento: false,
    numCredito: false,
    aplicaDescuento: true
}

const OBJ_DESABILITAR_SUSPENCION_DESCUENTO = {
    movimiento: false,
    fechaInicio: true,
    fecha: false,
    sdi: true,
    motivoBaja: true,
    folio: true,
    dias: true,
    articulo33: true,
    salarioOtrosSeguros: true,
    salarioIvCv: true,
    tipoDescuento: true,
    valorDescuento: true,
    numCredito: true,
    aplicaDescuento: true

}

const OBJ_DESABILITAR_REINICIO_DESCUENTO = {
    movimiento: false,
    fechaInicio: false,
    sdi: true,
    motivoBaja: true,
    folio: true,
    dias: true,
    articulo33: true,
    salarioOtrosSeguros: true,
    salarioIvCv: true,
    tipoDescuento: false,
    valorDescuento: false,
    numCredito: false,
    aplicaDescuento: true

}

const OBJ_DESABILITAR_PORSENTAJE1 = {
    movimiento: false,
    fechaInicio: false,
    sdi: true,
    motivoBaja: true,
    folio: true,
    dias: true,
    articulo33: true,
    salarioOtrosSeguros: true,
    salarioIvCv: true,
    tipoDescuento: false,
    valorDescuento: false,
    numCredito: false,
    aplicaDescuento: false
}

const OBJ_DESABILITAR_PORSENTAJE2 = {
    movimiento: false,
    fechaInicio: false,
    sdi: true,
    motivoBaja: true,
    folio: true,
    dias: true,
    articulo33: true,
    salarioOtrosSeguros: true,
    salarioIvCv: true,
    tipoDescuento: false,
    valorDescuento: false,
    numCredito: false,
    aplicaDescuento: true
}

const OBJ_DESABILITAR_PORSENTAJE3 = {
    movimiento: false,
    fechaInicio: false,
    sdi: true,
    motivoBaja: true,
    folio: true,
    dias: true,
    articulo33: true,
    salarioOtrosSeguros: true,
    salarioIvCv: true,
    tipoDescuento: false,
    valorDescuento: false,
    numCredito: true,
    aplicaDescuento: false
}

const OBJ_DESABILITAR_PORSENTAJE4 = {
    movimiento: false,
    fechaInicio: false,
    sdi: true,
    motivoBaja: true,
    folio: true,
    dias: true,
    articulo33: true,
    salarioOtrosSeguros: true,
    salarioIvCv: true,
    tipoDescuento: false,
    valorDescuento: false,
    numCredito: true,
    aplicaDescuento: true
}

const OBJ_DESABILITAR_MODIF_TIPO_DESCUENTO = {
    movimiento: false,
    fechaInicio: false,
    sdi: true,
    motivoBaja: true,
    folio: true,
    dias: true,
    articulo33: true,
    salarioOtrosSeguros: true,
    salarioIvCv: true,
    tipoDescuento: false,
    valorDescuento: false,
    numCredito: true,
    aplicaDescuento: true

}

const OBJ_DESABILITAR_MODIF_VALOR_DESCUENTO = {
    movimiento: false,
    fechaInicio: false,
    sdi: true,
    motivoBaja: true,
    folio: true,
    dias: true,
    articulo33: true,
    salarioOtrosSeguros: true,
    salarioIvCv: true,
    tipoDescuento: true,
    valorDescuento: false,
    numCredito: true,
    aplicaDescuento: true

}

const OBJ_DESABILITAR_MODIF_NUMERO_CREDITO = {
    movimiento: false,
    fechaInicio: false,
    sdi: true,
    motivoBaja: true,
    folio: true,
    dias: true,
    articulo33: true,
    salarioOtrosSeguros: true,
    salarioIvCv: true,
    tipoDescuento: false,
    valorDescuento: false,
    numCredito: false,
    aplicaDescuento: true

}

const PAGINACION_INICIAL = {
    registrosPorPagina: 100,
    numeroPagina: 0,
    join: {
        ttTrabajadorSua: "alias_ttTrabajadorSua"
    }
}

const MENSAJE_REQUERIDO = "Atributo requerido";

export class TabMovimientosTrabajadorSua extends Component {

    constructor(props) {
        super(props);
        this.state = {

            ver: false,
            value: null,
            errorFechaSubsecuente: false,
            trabajador: this.props.trabajador,
            movimiento: {},
            errores: {},
            paginacion: { ...PAGINACION_INICIAL },
            tipoMovimientos: [
                { value: '02', label: 'Baja' },
                { value: '08', label: 'Reingreso' },
                { value: '07', label: 'Modificación de Salario' },
                { value: '12', label: 'Incapacidad' },
                { value: '11', label: 'Ausentismo' },
                { value: '15', label: 'Inicio crédito vivienda' },
                { value: '16', label: 'Suspensión de descuento' },
                { value: '17', label: 'Reidsenube de descuento' },
                { value: '18', label: 'Modif. Tipo de Descuento' },
                { value: '19', label: 'Modif. Valor Descuento' },
                { value: '20', label: 'Modif. Número de Crédito' }
            ],
            motivosDeBaja: [
                { value: '1', label: 'Termino de contrato' },
                { value: '2', label: 'Separación voluntaria' },
                { value: '3', label: 'Abandono de empleo' },
                { value: '4', label: 'Defunción' },
                { value: '5', label: 'Clausura' },
                { value: '6', label: 'Otra' },
                { value: '7', label: 'Ausentismo' },
                { value: '8', label: 'Rescisión de contrato' },
                { value: '9', label: 'Jubilación' },
                { value: '0', label: 'Pensión' },
            ],
            ramoSeguros: [
                { value: '1', label: '1 Riesgos de Trabajo' },
                { value: '2', label: '2 Enfermedad General' },
                { value: '3', label: '3 Maternidad' },
                { value: '4', label: '4 Licencia 140 Bis' }
            ],
            tipoRiesgos: [
                { value: '1', label: '1 Accidente de Trabajo' },
                { value: '2', label: '2 Accidente de Trayecto' },
                { value: '3', label: '3 Enfermedad Profesional' }
            ],
            secuelaConcecuencias: [
                { value: '0', label: '0 Ninguna' },
                { value: '1', label: '1 Incapacidad Temporal' },
                { value: '2', label: '2 Valuacion inicial Provisional' },
                { value: '3', label: '3 Valuacion inicial Definitiva' },
                { value: '4', label: '4 Defuncion' },
                { value: '5', label: '5 Recaida' },
                { value: '6', label: '6 Valuacion Post. A la Fecha Alta' },
                { value: '7', label: '7 Revaluacion Provisional' },
                { value: '8', label: '8 Recaida sin alta medica' },
                { value: '9', label: '9 Revaluacion definitiva' },
            ],
            controlIncapacidades: [{ value: '0', label: '0 Ninguna' },
            { value: '1', label: '1 Unica' },
            { value: '2', label: '2 Inicial' },
            { value: '3', label: '3 Subsecuente' },
            { value: '4', label: '4 Alta Medica o ST-2' },
            { value: '5', label: '5 Valuacion o ST-3' },
            { value: '6', label: '6 Defuncion o ST-3' },
            ],
            controlIncapacidadNinguna: [{ value: '0', label: '0 Ninguna' }],
            controlIncapacidadTemporal: [{ value: '1', label: '1 Unica' },
            { value: '2', label: '2 Inicial' },
            { value: '3', label: '3 Subsecuente' },
            { value: '4', label: '4 Alta Medica o ST-2' },],

            controlIncapacidadValuacionInicial: [{ value: '5', label: '5 Valuacion o ST-3' }],

            controlIncapacidadDefuncion: [{ value: '6', label: '6 Defuncion o ST-3' }],

            controlIncapacidadRecaida: [{ value: '1', label: '1 Unica' },
            { value: '2', label: '2 Inicial' },
            { value: '3', label: '3 Subsecuente' },
            { value: '4', label: '4 Alta Medica o ST-2' }],

            controlIncapacidadesUica: [{ value: '0', label: '0 Ninguna' },
            { value: '1', label: '1 Unica' },
            { value: '2', label: '2 Inicial' },
            { value: '3', label: '3 Subsecuente' },
            { value: '4', label: '4 Alta Medica o ST-2' },
            { value: '5', label: '5 Valuacion o ST-3' },
            { value: '6', label: '6 Defuncion o ST-3' },
            ],
            controlIncapacidadesEnfermedadGeneral: [
                { value: '1', label: '1 Unica' },
                { value: '2', label: '2 Inicial' },
                { value: '3', label: '3 Subsecuente' },
                { value: '4', label: '4 Alta Medica o ST-2' },
            ],
            controlIncapacidadesMaternidad: [{ value: '7', label: '7 Pretanal' },
            { value: '8', label: '8 Enlace' },
            { value: '9', label: '9 Postnatal' }],

            controlIncapacidades5: [{ value: '5', label: '5 Valuacion o ST-3' }],
            controlIncapacidades6: [{ value: '6', label: '6 Defuncion o ST-3' }],
            controlIncapacidades0: [{ value: '0', label: '0 Ninguna' }],

            deshabilitado: { ...OBJ_HABILITADO },
            mostrarCalendario: true,
            mostrarBorrarTrabajador: false,
            mostrarModalActualizarIncapacidades: false,
            tiposDescuentos: [
                { value: "1", label: "Porcentaje" },
                { value: "2", label: "Cuota Fija" },
                { value: "3", label: "Factor de descuento" }
            ],
            aplicaDescuento: false
        };
        this.buscarMovimientosTrabajador();
    }

    desabilitarInicioIncidencias = () => {
        let objDesabilitar = { ...OBJ_INCAPACIDAD_INICIO };
        this.setState({
            deshabilitado: objDesabilitar
        });
    }
    buscarMovimientosTrabajador = () => {
        let { paginacion, trabajador } = this.state;
        paginacion.ordenamientos = [];
        paginacion.restriccionesDinamicas = [
            {
                tipoRestriccion: "eq",
                nombrePropiedad: "ttTrabajadorSua",
                valorPropiedad: { id: trabajador.id }
            }
        ];
        paginacion.ordenamientos.push({
            tipo: 'asc',
            nombrePropiedad: 'fecha'
        });
        servicioHttp.consumirPostHttp('movimiento_sua/consultar.json', paginacion).then(response => {
            this.setState({
                paginacion: response.data.objeto
            });
        }).catch(error => {

        });
    }

    sumarFecha = () => {
        let { movimiento } = this.state;
        var fecha = new Date(movimiento.fecha);
        var dias = movimiento.dias;
        fecha.setDate(fecha.getDate() + dias);
        movimiento.fechaFinalIncapacidad = fecha;
        this.setState({ movimiento });

    }
    sumarDiasFechaInicio = () => {
        let { movimiento } = this.state;
        let movimientoFecha = {};
        movimientoFecha.fecha = movimiento.fecha;
        movimientoFecha.dias = movimiento.dias - 1;
        servicioHttp.consumirPostHttp('/movimiento_sua/sumar_fecha.json', movimientoFecha).then(response => {

            let fecha = new Date(response.data);
            movimiento.fechaFinalIncapacidad = fecha;
            this.setState({
                movimiento
            });
        }).catch(error => {

        });

    }

    asignarValores = (event, mayusculas) => {
        let { controlIncapacidadRecaida, controlIncapacidadDefuncion, controlIncapacidadValuacionInicial, controlIncapacidadTemporal, controlIncapacidadNinguna, controlIncapacidadesEnfermedadGeneral, controlIncapacidades0, controlIncapacidadesMaternidad, movimiento } = this.state;
        let idElemento = event.target.id;
        let valor = event.target.value;
        servicioObjetos.asignarAtributosObjeto(event, this, mayusculas);
        this.obtenerFechaDiasCero();
        /*  if (movimiento.tipoMovimiento.value === "16" && movimiento.fecha != null) {
             this.buscarCreditoReciente();
         } */
        // if(!servicioObjetos.esObjetoVacio(movimiento.fecha))
        // movimiento.fechaFinalIncapacidad = movimiento.fecha;
        if (idElemento === "movimiento.tipoMovimiento") {
            let objDesabilitar = { ...OBJ_HABILITADO };
            if (valor.value === "02") {
                movimiento.sdi = null;
                objDesabilitar = { ...OBJ_DESABILITAR_BAJA };
            }
            if (valor.value === "07") {
                movimiento.motivoBaja = null;

                objDesabilitar = { ...OBJ_DESABILITAR_MODIFICACION };
            }
            if (valor.value === "08") {
                movimiento.motivoBaja = null;
                objDesabilitar = { ...OBJ_DESABILITAR_REINGRESO };
            }
            if (valor.value === "12") {
                movimiento.porcentaje = "0";
                movimiento.sdi = null;
                movimiento.motivoBaja = null;
                objDesabilitar = { ...OBJ_DESABILITAR_BAJA };
                objDesabilitar = { ...OBJ_DESABILITAR_REINGRESO };
                this.setState({ mostrarModalActualizarIncapacidades: true });
                movimiento.ramoSeguro = undefined;
                movimiento.tipoRiesgo = undefined;
                movimiento.secuelaOconcecuencia = undefined;
                movimiento.controlIncapacidad = undefined;
                movimiento.fecha = null;
                movimiento.fechaFinalIncapacidad = null;
                movimiento.folio = null;
                movimiento.dias = null;
                this.desabilitarInicioIncidencias();
            }
            if (valor.value === "11") {
                movimiento.sdi = null;
                movimiento.motivoBaja = null;
                objDesabilitar = { ...OBJ_DESABILITAR_AUSENTISMO };
            }
            if (valor.value === "15") {
                objDesabilitar = { ...OBJ_DESABILITAR_CREDITO_VIVIENDA };
            }
            if (valor.value === "16") {
                objDesabilitar = { ...OBJ_DESABILITAR_SUSPENCION_DESCUENTO };
            }
            if (valor.value === "17") {
                objDesabilitar = { ...OBJ_DESABILITAR_REINICIO_DESCUENTO };
            }
            if (valor.value === "18") {
                objDesabilitar = { ...OBJ_DESABILITAR_MODIF_TIPO_DESCUENTO };
            }
            if (valor.value === "19") {
                objDesabilitar = { ...OBJ_DESABILITAR_MODIF_VALOR_DESCUENTO };
            }
            if (valor.value === "20") {
                objDesabilitar = { ...OBJ_DESABILITAR_MODIF_NUMERO_CREDITO };
            }
            this.setState({
                deshabilitado: objDesabilitar
            });
        }
        if (idElemento === "movimiento.tipoRiesgo") {

        }

        if (idElemento === "movimiento.secuelaOconcecuencia") {

            let objDesabilitar = { ...OBJ_CONTROL_INCAPACIDAD_INICIO };
            if (valor.value === "0") {
                this.setState({ controlIncapacidades: controlIncapacidadNinguna });
                objDesabilitar = { ...OBJ_CONTROL_INCAPACIDAD };
                movimiento.fecha = null;
                movimiento.fechaFinalIncapacidad = null;
                movimiento.folio = null;
                movimiento.dias = null;
            }
            if (valor.value === "1") {
                objDesabilitar = { ...OBJ_CONTROL_INCAPACIDAD };
                this.setState({
                    controlIncapacidades: controlIncapacidadTemporal
                });
                movimiento.fecha = null;
                movimiento.fechaFinalIncapacidad = null;
                movimiento.folio = null;
                movimiento.dias = null;
            }
            if (valor.value === "2") {
                movimiento.controlIncapacidad = undefined;
                objDesabilitar = { ...OBJ_CONTROL_INCAPACIDAD };
                this.setState({ controlIncapacidades: controlIncapacidadValuacionInicial });
                movimiento.fecha = null;
                movimiento.fechaFinalIncapacidad = null;
                movimiento.folio = null;
                movimiento.dias = null;
            }
            if (valor.value === "3") {
                movimiento.controlIncapacidad = undefined;
                objDesabilitar = { ...OBJ_CONTROL_INCAPACIDAD };
                this.setState({ controlIncapacidades: controlIncapacidadValuacionInicial });
                movimiento.fecha = null;
                movimiento.fechaFinalIncapacidad = null;
                movimiento.folio = null;
                movimiento.dias = null;
            }
            if (valor.value === "4") {

                this.setState({ controlIncapacidades: controlIncapacidadDefuncion });
                objDesabilitar = { ...OBJ_CONTROL_INCAPACIDAD };
                movimiento.fecha = null;
                movimiento.fechaFinalIncapacidad = null;
                movimiento.folio = null;
                movimiento.dias = null;
            }
            if (valor.value === "5") {
                this.setState({ controlIncapacidades: controlIncapacidadRecaida });
                objDesabilitar = { ...OBJ_CONTROL_INCAPACIDAD };
                movimiento.fecha = null;
                movimiento.fechaFinalIncapacidad = null;
                movimiento.folio = null;
                movimiento.dias = null;
            }

            if (valor.value === "6") {
                movimiento.controlIncapacidad = undefined;
                objDesabilitar = { ...OBJ_CONTROL_INCAPACIDAD };
                this.setState({ controlIncapacidades: controlIncapacidadValuacionInicial });
                movimiento.fecha = null;
                movimiento.fechaFinalIncapacidad = null;
                movimiento.folio = null;
                movimiento.dias = null;
            }
            if (valor.value === "7") {
                movimiento.controlIncapacidad = undefined;
                objDesabilitar = { ...OBJ_CONTROL_INCAPACIDAD };
                this.setState({ controlIncapacidades: controlIncapacidadValuacionInicial });
                movimiento.fecha = null;
                movimiento.fechaFinalIncapacidad = null;
                movimiento.folio = null;
                movimiento.dias = null;
            }
            if (valor.value === "8") {
                this.setState({ controlIncapacidades: controlIncapacidadTemporal });
                objDesabilitar = { ...OBJ_CONTROL_INCAPACIDAD };
                movimiento.fecha = null;
                movimiento.fechaFinalIncapacidad = null;
                movimiento.folio = null;
                movimiento.dias = null;
            }
            if (valor.value === "9") {
                this.setState({ controlIncapacidades: controlIncapacidadValuacionInicial });
                objDesabilitar = { ...OBJ_CONTROL_INCAPACIDAD };
                movimiento.fecha = null;
                movimiento.fechaFinalIncapacidad = null;
                movimiento.folio = null;
                movimiento.dias = null;
            }
            this.setState({
                deshabilitado: objDesabilitar
            });
        }
        if (idElemento === "movimiento.ramoSeguro") {
            let objDesabilitar = { ...OBJ_HABILITADO };
            if (valor.value === "1") {
                movimiento.fecha = null;
                movimiento.fechaFinalIncapacidad = null;
                movimiento.folio = null;
                movimiento.dias = null;
            }
            if (valor.value === "2") {
                objDesabilitar = { ...OBJ_RAMO_ENFERMEDAD_GENERAL };
                this.setState({ controlIncapacidades: controlIncapacidadesEnfermedadGeneral });
                movimiento.secuelaOconcecuencia = undefined;
                movimiento.tipoRiesgo = undefined;
                movimiento.controlIncapacidad = undefined;
                movimiento.fecha = null;
                movimiento.fechaFinalIncapacidad = null;
                movimiento.folio = null;
                movimiento.dias = null;

            }
            if (valor.value === "3") {
                objDesabilitar = { ...OBJ_RAMO_MATERNIDAD };
                this.setState({
                    controlIncapacidades: controlIncapacidadesMaternidad
                });
                movimiento.secuelaOconcecuencia = undefined;
                movimiento.tipoRiesgo = undefined;
                movimiento.controlIncapacidad = undefined;
                movimiento.fecha = null;
                movimiento.fechaFinalIncapacidad = null;
                movimiento.folio = null;
                movimiento.dias = null;
            }
            if (valor.value === "4") {

                objDesabilitar = { ...OBJ_RAMO_MATERNIDAD };
                this.setState({
                    controlIncapacidades: controlIncapacidades0
                });
                movimiento.secuelaOconcecuencia = undefined;
                movimiento.tipoRiesgo = undefined;
                movimiento.controlIncapacidad = undefined;
                movimiento.fecha = null;
                movimiento.fechaFinalIncapacidad = null;
                movimiento.folio = null;
                movimiento.dias = null;
            }
            this.setState({
                deshabilitado: objDesabilitar
            });
        }
        if (idElemento === "movimiento.tipoDescuento") {
            let objDesabilitar = { ...OBJ_HABILITADO };
            if (movimiento.tipoMovimiento.value === "15" || movimiento.tipoMovimiento.value === "17" || movimiento.tipoMovimiento.value === "20") {
                if (valor === "1") {
                    objDesabilitar = { ...OBJ_DESABILITAR_PORSENTAJE1 };
                }
                if (valor === "2") {
                    objDesabilitar = { ...OBJ_DESABILITAR_PORSENTAJE2 };
                    this.resetTipoDescuento();
                }
                if (valor === "3") {
                    objDesabilitar = { ...OBJ_DESABILITAR_PORSENTAJE2 };
                    this.resetTipoDescuento();
                }
                this.setState({
                    deshabilitado: objDesabilitar
                });
            }
            if (movimiento.tipoMovimiento.value === "18" || movimiento.tipoMovimiento.value === "19") {
                if (valor === "1") {
                    objDesabilitar = { ...OBJ_DESABILITAR_PORSENTAJE3 };
                }
                if (valor === "2") {
                    objDesabilitar = { ...OBJ_DESABILITAR_PORSENTAJE4 };
                    this.resetTipoDescuento();
                }
                if (valor === "3") {
                    objDesabilitar = { ...OBJ_DESABILITAR_PORSENTAJE4 };
                    this.resetTipoDescuento();
                }
                this.setState({
                    deshabilitado: objDesabilitar
                });
            }
        }
        if (idElemento === "movimiento.controlIncapacidad") {

            let objDesabilitar = { ...OBJ_HABILITADO };
            if (valor.value === "0") {

                if (movimiento.ramoSeguro.value === "1") {
                    objDesabilitar = { ...OBJ_CONTROL_ICAPACIDAD_NINGUNO };
                } else {
                    objDesabilitar = { ...OBJ_CONTROL_ICAPACIDAD_NINGUNO_DES_SECUELA };
                }
                if (movimiento.ramoSeguro.value === "4") {
                    objDesabilitar = { ...OBJ_4_LICENCIA_CTRL_NINGUNO };

                }
                movimiento.fecha = null;
                movimiento.fechaFinalIncapacidad = null;
                movimiento.folio = null;
                movimiento.dias = null;
            }
            if (valor.value === "1") {
                if (movimiento.ramoSeguro.value === "1") {
                    objDesabilitar = { ...OBJ_CONTROL_INCAPACIDAD_1_4 };
                } else {
                    objDesabilitar = { ...OBJ_CONTROL_INCAPACIDAD_1_4_DES_SECUELA };
                }
                movimiento.fecha = null;
                movimiento.fechaFinalIncapacidad = null;
                movimiento.folio = null;
                movimiento.dias = null;
            }
            if (valor.value === "2") {
                if (movimiento.ramoSeguro.value === "1") {
                    objDesabilitar = { ...OBJ_CONTROL_INCAPACIDAD_1_4 };
                } else {
                    objDesabilitar = { ...OBJ_CONTROL_INCAPACIDAD_1_4_DES_SECUELA };
                }
                movimiento.fecha = null;
                movimiento.fechaFinalIncapacidad = null;
                movimiento.folio = null;
                movimiento.dias = null;
            }
            if (valor.value === "3") {
                if (movimiento.ramoSeguro.value === "1") {
                    objDesabilitar = { ...OBJ_CONTROL_INCAPACIDAD_1_4 };
                } else {
                    objDesabilitar = { ...OBJ_CONTROL_INCAPACIDAD_1_4_DES_SECUELA };
                }
                movimiento.fecha = null;
                movimiento.fechaFinalIncapacidad = null;
                movimiento.folio = null;
                movimiento.dias = null;
            }
            if (valor.value === "4") {
                if (movimiento.ramoSeguro.value === "1") {
                    objDesabilitar = { ...OBJ_CONTROL_INCAPACIDAD_1_4 };
                } else {
                    objDesabilitar = { ...OBJ_CONTROL_INCAPACIDAD_1_4_DES_SECUELA };
                }
                movimiento.fecha = null;
                movimiento.fechaFinalIncapacidad = null;
                movimiento.folio = null;
                movimiento.dias = null;
            }
            if (valor.value === "5") {
                if (movimiento.ramoSeguro.value === "1") {
                    objDesabilitar = { ...OBJ_CONTROL_INCAPACIDAD_5 };
                } else {
                    objDesabilitar = { ...OBJ_CONTROL_INCAPACIDAD_5_DES_SECUELA };
                }
                movimiento.fecha = null;
                movimiento.fechaFinalIncapacidad = null;
                movimiento.folio = null;
                movimiento.dias = null;
            }
            if (valor.value === "6") {
                if (movimiento.ramoSeguro.value === "1") {
                    objDesabilitar = { ...OBJ_CONTROL_DEFUNCION_6 };
                } else {
                    objDesabilitar = { ...OBJ_CONTROL_DEFUNCION_6_DES_SECUELA };
                }
                movimiento.fecha = null;
                movimiento.fechaFinalIncapacidad = null;
                movimiento.folio = null;
                movimiento.dias = null;
            }
            if (valor.value === "7" || valor.value === "8" || valor.value === "9") {
                if (movimiento.ramoSeguro.value === "1") {
                    objDesabilitar = { ...OBJ_CONTROL_7_9 };
                } else {
                    objDesabilitar = { ...OBJ_CONTROL_7_9_DES_SECUELA };
                }
                movimiento.fecha = null;
                movimiento.fechaFinalIncapacidad = null;
                movimiento.folio = null;
                movimiento.dias = null;
            }

            this.setState({
                deshabilitado: objDesabilitar
            });

        }
        if (movimiento.secuelaOconcecuencia !== undefined && movimiento.controlIncapacidad !== undefined)
            if (movimiento.secuelaOconcecuencia.value === "0" && movimiento.controlIncapacidad.value === "0") {
                movimiento.dias = "0";
            }

        if (idElemento === "movimiento.fecha") {
            if (movimiento.tipoMovimiento.value === "16" && movimiento.fecha !== null) {
                this.buscarCreditoReciente();
            }
            if (movimiento.tipoMovimiento.value === "17" && movimiento.fecha !== null) {
                this.buscarCreditoReciente();
            }
            if (movimiento.tipoMovimiento.value === "18" && movimiento.fecha !== null) {
                this.buscarCreditoReciente();
            }
            if (movimiento.tipoMovimiento.value === "19" && movimiento.fecha !== null) {
                this.buscarCreditoReciente();
            }
            if (movimiento.tipoMovimiento.value === "20" && movimiento.fecha !== null) {
                this.buscarCreditoReciente();
            }
        }

    }

    obtenerFechaDiasCero = () => {
        let { movimiento } = this.state;
        if (movimiento.secuelaOconcecuencia !== undefined && movimiento.controlIncapacidad !== undefined) {
            if (movimiento.secuelaOconcecuencia.value === "0" && movimiento.controlIncapacidad.value === "0") {
                movimiento.fechaFinalIncapacidad = movimiento.fecha;
                this.setState({ movimiento });

            }
            if (movimiento.secuelaOconcecuencia.value === "4" && movimiento.controlIncapacidad.value === "6") {
                movimiento.fechaFinalIncapacidad = movimiento.fecha;
                this.setState({ movimiento });

            }
        }
        if (movimiento.ramoSeguro !== undefined && movimiento.controlIncapacidad !== undefined) {
            if (movimiento.ramoSeguro.value === "4" && movimiento.controlIncapacidad.value === "0") {
                movimiento.fechaFinalIncapacidad = movimiento.fecha;

                this.setState({ movimiento });

            }
            if (movimiento.controlIncapacidad.value === "5") {
                movimiento.fechaFinalIncapacidad = movimiento.fecha;
                this.setState({ movimiento });

            }

        }

    }

    resetTipoDescuento = () => {
        this.setState({
            aplicaDescuento: false
        });
        setTimeout(() => {
            this.setState({ aplicaDescuento: false });
        }, 50);
    }

    guardarMovimiento = () => {
        let errores = this.validarFomularioMovimientos();
        this.setState({
            errores: errores
        });
        if (servicioObjetos.esObjetoVacio(errores)) {
            let { trabajador, movimiento, aplicaDescuento } = this.state;

            let movimientoFinal = { ...movimiento };
            movimientoFinal.tipoMovimiento = movimiento.tipoMovimiento.value;
            movimientoFinal.aplicaDescuento = aplicaDescuento ? "S" : "N";
            if (!servicioObjetos.esObjetoVacio(movimientoFinal.tipoDescuento)) {
                movimientoFinal.tipoDescuento = movimiento.tipoDescuento;
            }
            if (!servicioObjetos.esObjetoVacio(movimientoFinal.motivoBaja)) {
                movimientoFinal.motivoBaja = movimiento.motivoBaja.value;
            }
            movimientoFinal.articulo33 = null;
            if (movimiento.numCredito != null) {
                trabajador.numeroCredito = movimiento.numCredito;
            }

            trabajador.movimientos = [
                movimientoFinal
            ];
        }
        return errores;
    }

    validarFormularioIncapacidades = () => {
        let { movimiento } = this.state;
        let errores = {};
        var expreReg = /^[A-Z]{2}\d{6}$/;
        var validacionFolio = expreReg.exec(movimiento.folio);


        if (!servicioObjetos.esObjetoVacio(movimiento.controlIncapacidad)) {
            if (movimiento.controlIncapacidad.value === "1" || movimiento.controlIncapacidad.value === "2" || movimiento.controlIncapacidad.value === "3" || movimiento.controlIncapacidad.value === "4" || movimiento.controlIncapacidad.value === "7" || movimiento.controlIncapacidad.value === "8") {
                if (!validacionFolio)
                    errores.folio = "El folio debe de ser 2 letras y 6 numeros";
                if (servicioObjetos.esObjetoVacio(movimiento.folio)) {
                    errores.folio = MENSAJE_REQUERIDO;
                }
            }
        }

        if (servicioObjetos.esObjetoVacio(movimiento.ramoSeguro))
            errores.ramoSeguro = MENSAJE_REQUERIDO;

        if (!servicioObjetos.esObjetoVacio(movimiento.ramoSeguro)) {
            if (movimiento.ramoSeguro.value === "1") {
                if (servicioObjetos.esObjetoVacio(movimiento.tipoRiesgo))
                    errores.tipoRiesgo = MENSAJE_REQUERIDO;
            }
        }

        if (servicioObjetos.esObjetoVacio(movimiento.controlIncapacidad))
            errores.controlIncapacidad = MENSAJE_REQUERIDO;
        if (servicioObjetos.esObjetoVacio(movimiento.fecha))
            errores.fecha = MENSAJE_REQUERIDO;
        if (servicioObjetos.esObjetoVacio(movimiento.fechaFinalIncapacidad))
            errores.fechaFinalIncapacidad = MENSAJE_REQUERIDO;
        if (movimiento.ramoSeguro !== undefined && movimiento.controlIncapacidad !== undefined) {
            if (movimiento.ramoSeguro.value === "3" && movimiento.controlIncapacidad.value === "7") {
                if (movimiento.dias > 90)
                    errores.dias = "Dias permitidos 90";
            }
            if (movimiento.ramoSeguro.value === "3" && movimiento.controlIncapacidad.value === "9") {
                if (movimiento.dias > 90)
                    errores.dias = "Dias permitidos 90";
            }
            if (movimiento.ramoSeguro.value === "3" && movimiento.controlIncapacidad.value === "8") {
                if (movimiento.dias > 30)
                    errores.dias = "Dias permitidos 30";
            }

            if (movimiento.ramoSeguro.value === "4") {
                if (movimiento.dias > 28)
                    errores.dias = "Dias permitidos 28";
            }
            if (movimiento.ramoSeguro.value === "1") {
                if (movimiento.dias > 30)
                    errores.dias = "Dias permitidos 30";
            }
            if (movimiento.ramoSeguro.value === "2") {
                if (movimiento.dias > 30)
                    errores.dias = "Dias permitidos 30";
            }

        }
        if (movimiento.porcentaje > 100)
            errores.porcentaje = "Debe de se menor o igual a 100";
        return errores;

    }

    guardarIncapacidad = () => {
        let errores = this.validarFormularioIncapacidades();
        this.setState({
            errores: errores
        });
        if (servicioObjetos.esObjetoVacio(errores)) {
            this.validarFechaSubsecuente();
        }
    }

    validarTipoMovimiento = (movimiento, errores) => {
        switch (movimiento.tipoMovimiento.value) {
            case "11":
                movimiento.vigencia = "0";
                if (servicioObjetos.esObjetoVacio(movimiento.fecha))
                    errores.fecha = MENSAJE_REQUERIDO;
                if (servicioObjetos.esObjetoVacio(movimiento.tipoDescuento))
                    errores.dias = MENSAJE_REQUERIDO;
                break;
            case "15":
                movimiento.vigencia = "0";
                if (servicioObjetos.esObjetoVacio(movimiento.fecha))
                    errores.fecha = MENSAJE_REQUERIDO;
                if (servicioObjetos.esObjetoVacio(movimiento.tipoDescuento))
                    errores.tipoDescuento = MENSAJE_REQUERIDO;
                if (servicioObjetos.esObjetoVacio(movimiento.valorDescuento))
                    errores.valorDescuento = MENSAJE_REQUERIDO;
                if (servicioObjetos.esObjetoVacio(movimiento.numCredito))
                    errores.numCredito = MENSAJE_REQUERIDO;
                break;
            case "16":
                movimiento.vigencia = "0";
                if (servicioObjetos.esObjetoVacio(movimiento.fecha))
                    errores.fecha = MENSAJE_REQUERIDO;
                break;
            case "17":
                movimiento.vigencia = "0";
                if (servicioObjetos.esObjetoVacio(movimiento.fecha))
                    errores.fecha = MENSAJE_REQUERIDO;
                if (servicioObjetos.esObjetoVacio(movimiento.tipoDescuento))
                    errores.tipoDescuento = MENSAJE_REQUERIDO;
                if (servicioObjetos.esObjetoVacio(movimiento.valorDescuento))
                    errores.valorDescuento = MENSAJE_REQUERIDO;
                if (servicioObjetos.esObjetoVacio(movimiento.numCredito))
                    errores.numCredito = MENSAJE_REQUERIDO;
                break;
            case "18":
                movimiento.vigencia = "0";
                if (servicioObjetos.esObjetoVacio(movimiento.fecha))
                    errores.fecha = MENSAJE_REQUERIDO;
                if (servicioObjetos.esObjetoVacio(movimiento.tipoDescuento))
                    errores.tipoDescuento = MENSAJE_REQUERIDO;
                if (servicioObjetos.esObjetoVacio(movimiento.valorDescuento))
                    errores.valorDescuento = MENSAJE_REQUERIDO;
                break;

            case "19":
                movimiento.vigencia = "0";
                if (servicioObjetos.esObjetoVacio(movimiento.fecha))
                    errores.fecha = MENSAJE_REQUERIDO;
                if (servicioObjetos.esObjetoVacio(movimiento.valorDescuento))
                    errores.valorDescuento = MENSAJE_REQUERIDO;
                break;

            case "20":
                movimiento.vigencia = "0";
                if (servicioObjetos.esObjetoVacio(movimiento.fecha))
                    errores.fecha = MENSAJE_REQUERIDO;
                if (servicioObjetos.esObjetoVacio(movimiento.tipoDescuento))
                    errores.tipoDescuento = MENSAJE_REQUERIDO;
                if (servicioObjetos.esObjetoVacio(movimiento.valorDescuento))
                    errores.valorDescuento = MENSAJE_REQUERIDO;
                if (servicioObjetos.esObjetoVacio(movimiento.numCredito))
                    errores.numCredito = MENSAJE_REQUERIDO;
                break;
            default:
                break;
        }
    }

    validarFomularioMovimientos = () => {
        let { movimiento, aplicaDescuento } = this.state;
        let errores = {};
        var expresionSalario = /^(\d{1,5})(.)(\d{1,2})$/;
        var porcentaje = /^(\d{1,2})(.)(\d{2})$/;
        var cuota = /^(\d{5})(.)(\d{2})$/;
        var factor = /^(\d{3})(.)(\d{4})$/;


        if (servicioObjetos.esObjetoVacio(movimiento.tipoMovimiento)) {
            errores.tipoMovimiento = MENSAJE_REQUERIDO;
        }

        if (!servicioObjetos.esObjetoVacio(movimiento.tipoMovimiento)) {
            this.validarTipoMovimiento(movimiento, errores);
        }

        if (!servicioObjetos.esObjetoVacio(movimiento.tipoMovimiento) && movimiento.tipoMovimiento.value === '02') {
            if (servicioObjetos.esObjetoVacio(movimiento.motivoBaja))
                errores.motivoBaja = MENSAJE_REQUERIDO;
            if (servicioObjetos.esObjetoVacio(movimiento.fecha))
                errores.fecha = MENSAJE_REQUERIDO;
            if (!servicioObjetos.esObjetoVacio(movimiento.motivoBaja) && servicioObjetos.esObjetoVacio(movimiento.motivoBaja.value))
                errores.motivoBaja = MENSAJE_REQUERIDO;
        }
        if (!servicioObjetos.esObjetoVacio(movimiento.tipoMovimiento) && movimiento.tipoMovimiento.value === '08') {
            var validacionSalario = expresionSalario.exec(movimiento.sdi);
            if (!validacionSalario)
                errores.sdi = "El formato es invalido debe de ser 00000.00";
            if (servicioObjetos.esObjetoVacio(movimiento.sdi))
                errores.sdi = MENSAJE_REQUERIDO;
            if (servicioObjetos.esObjetoVacio(movimiento.fecha))
                errores.fecha = MENSAJE_REQUERIDO;
        }
        if (movimiento.articulo33 === true) {
            if (servicioObjetos.esObjetoVacio(movimiento.salarioOtrosSeguros))
                errores.salarioOtrosSeguros = MENSAJE_REQUERIDO;
        }
        if (!servicioObjetos.esObjetoVacio(movimiento.tipoDescuento) && movimiento.tipoDescuento === '1') {
            var validacionPorcentaje = porcentaje.exec(movimiento.valorDescuento);
            if (!validacionPorcentaje)
                errores.valorDescuento = "El formato es invalido, debe de ser 00.00";
            if (aplicaDescuento && !(movimiento.valorDescuento === "20.00" || movimiento.valorDescuento === "25.00" || movimiento.valorDescuento === "30.00")) {
                errores.aplicaDescuento =
                    this.growl.show({
                        severity: 'error', summary: 'Error',
                        detail: "No se puede aplicar la tabla de disminución para el valor de descuento diferente de 20, 25 y 30."
                    });
            }

            if (aplicaDescuento === false && (movimiento.valorDescuento === "20.00" || movimiento.valorDescuento === "25.00" || movimiento.valorDescuento === "30.00")) {
                errores.aplicaDescuento =
                    this.growl.show({
                        severity: 'error', summary: 'Error',
                        detail: "Debe aplicar la tabla de disminución para el valor de descuento equivalente a 20, 25 y 30."
                    });
            }
        }
        if (!servicioObjetos.esObjetoVacio(movimiento.tipoDescuento) && movimiento.tipoDescuento === '2') {
            var validacionCuota = cuota.exec(movimiento.valorDescuento);
            if (!validacionCuota)
                errores.valorDescuento = "El formato es invalido, debe de ser 00000.00";
            movimiento.aplicaDescuento = aplicaDescuento ? null : "N";
        }
        if (!servicioObjetos.esObjetoVacio(movimiento.tipoDescuento) && movimiento.tipoDescuento === '3') {
            var validacionFactor = factor.exec(movimiento.valorDescuento);
            if (!validacionFactor)
                errores.valorDescuento = "El formato es invalido, debe de ser 000.0000";
            movimiento.aplicaDescuento = aplicaDescuento ? null : "N";
        }

        return errores;
    }

    formatearColumnaFecha = (data, rowColumn) => {
        return <div>{servicioFormatos.formatearFecha(data.fecha)}</div>;
    }
    formatearColumnaFechaTermino = (data, rowColumn) => {
        return <div>{servicioFormatos.formatearFecha(data.fechaFinalIncapacidad)}</div>;
    }

    formatearTipoMovimiento = (data, rowColumn) => {
        return <div>{servicioFormatos.formatoTipoMovimiento(data.tipoMovimiento)}</div>;
    }
    formatearRama = (data, rowColumn) => {
        return <div>{servicioFormatos.formatoRama(data.ramoSeguro)}</div>;

    }
    formatearTipoRiesgo = (data, rowColumn) => {
        return <div>{servicioFormatos.formatoTipoRiesgo(data.tipoRiesgo)}</div>;

    }
    formatearSecuencia = (data, rowColumn) => {
        return <div>{servicioFormatos.funcionSecuencia(data.secuelaOconcecuencia)}</div>;

    }
    formatearControl = (data, rowColumn) => {
        return <div>{servicioFormatos.funcionControlIncapacidad(data.controlIncapacidad)}</div>;
    }

    formatearTipoDescuento = (data, rowColumn) => {
        return <div>{servicioFormatos.formatoTipoDescuento(data.tipoDescuento)}</div>;
    }

    eliminarMovimientos = (event) => {
        this.setState({
            mostrarBorrarTrabajador: true,
            movimientoEliminar: event.data
        });
    }

    cerrarModalEliminarTrabajador = () => {
        this.setState({
            mostrarBorrarTrabajador: false
        });
    }

    cerrarModalActualizarIncapacidades = () => {
        let { ver } = this.state;
        this.setState({
            mostrarModalActualizarIncapacidades: false
        });
        if (ver === false) {
            this.setState({
                movimiento: {}, errores: {}
            });
        }
    }

    btnBorrarTrabajador = () => {
        let { movimientoEliminar } = this.state;
        servicioHttp.consumirPostHttp("/movimiento_sua/eliminar.json", { id: movimientoEliminar.id }).then(response => {
            if (response.data.error === true) {
                this.growl.show({ severity: 'error', summary: 'Error', detail: response.data.mensaje });
                this.cerrarModalEliminarTrabajador();
            } else {
                this.buscarMovimientosTrabajador();
                this.cerrarModalEliminarTrabajador();
                this.growl.show({ severity: 'success', summary: 'Éxito', detail: response.data.mensaje });
            }
        }).catch(error => {
            this.growl.show({ severity: 'error', summary: 'Error', detail: "Existe un error al eliminar el trabajador" });
        });
    }

    generaReporteMovimientos = () => {
        let { trabajador } = this.props;
        servicioArchivos.descargaArchivo('/movimiento_sua/reporte.json', { id: trabajador.id });
    }
    validarFechaSubsecuente = () => {
        let { movimiento, trabajador } = this.state;
        let movimientoTrabajador = {};

        movimientoTrabajador.fecha = movimiento.fecha;
        movimientoTrabajador.fechaFinalIncapacidad = movimiento.fechaFinalIncapacidad;
        movimientoTrabajador.idTrabajador = trabajador.id;
        movimientoTrabajador.sexoTrabajador = trabajador.sexo;
        if (movimiento.controlIncapacidad !== undefined) {
            movimientoTrabajador.controlIncapacidad = movimiento.controlIncapacidad.value;
        }
        if (movimiento.secuelaOconcecuencia !== undefined) {
            movimientoTrabajador.secuelaOconcecuencia = movimiento.secuelaOconcecuencia.value;
        }
        if (movimiento.ramoSeguro !== undefined) {
            movimientoTrabajador.ramoSeguro = movimiento.ramoSeguro.value;
        }
        servicioHttp.consumirPostHttp("/movimiento_sua/validar_fecha.json", movimientoTrabajador).then(response => {

            if (response.data.error === true) {
                this.growl.show({ severity: 'error', summary: 'Error', detail: response.data.mensaje });
                this.setState({ ver: false });
            } else {
                this.setState({ ver: true });
                if (response.data.mensaje !== undefined) {
                    this.growl.show({ severity: 'success', summary: 'Mensaje', detail: response.data.mensaje });
                }
                if (movimiento.ramoSeguro !== undefined)
                    movimiento.ramoSeguro = movimiento.ramoSeguro.value;
                if (movimiento.tipoRiesgo !== undefined)
                    movimiento.tipoRiesgo = movimiento.tipoRiesgo.value;
                if (movimiento.secuelaOconcecuencia !== undefined)
                    movimiento.secuelaOconcecuencia = movimiento.secuelaOconcecuencia.value;
                if (movimiento.controlIncapacidad !== undefined)
                    movimiento.controlIncapacidad = movimiento.controlIncapacidad.value;
                this.setState({ mostrarModalActualizarIncapacidades: false });
                let ttRegistroPatronal = {};
                ttRegistroPatronal.id = trabajador.ttRegistroPatronal;
                let ttPatron = {}
                ttPatron.id = trabajador.ttPatron;
                trabajador.ttRegistroPatronal = ttRegistroPatronal;
                trabajador.ttPatron = ttPatron;
                this.guardarMovimiento();

                servicioHttp.consumirPostHttp('trabajador_sua/guardar.json', trabajador).then(response => {
                    this.setState({ movimiento: {}, paginacion: {} });
                    this.buscarMovimientosTrabajador();
                    trabajador.ttPatron = ttPatron.id;
                    trabajador.ttRegistroPatronal = ttRegistroPatronal.id;
                    this.setState({ trabajador });
                    this.setState({ ver: true });
                    if (!response.data.error) {
                        this.growl.show({ severity: 'success', summary: 'Aviso', detail: response.data.mensaje, life: 6000 });
                    } else {
                        this.growl.show({ severity: 'error', summary: 'Aviso', detail: response.data.error, life: 6000 });
                    }

                }).catch(error => {

                });


            }


        }).catch(error => {
            this.growl.show({ severity: 'error', summary: 'Error', detail: 'error en el servidor' });
        });

    }
    setValue = (event) => {
        let { movimiento } = this.state;
        movimiento.articulo33 = event;

        this.setState({ movimiento });
        let objDesabilitar = { ...OBJ_DESABILITAR_MODIFICACION };

        if (movimiento.articulo33 === true) {
            objDesabilitar = { ...OBJETO_ART33 };
        }
        this.setState({
            deshabilitado: objDesabilitar
        });

    }
    cancelarIncidencia = () => {
        this.setState({ mostrarModalActualizarIncapacidades: false, movimiento: {}, ver: false, errores: {} });
    }
    actualizarDiasFechaFinal = () => {
        let { movimiento } = this.state;

        movimiento.dias = null;
        movimiento.fechaFinalIncapacidad = null;

    }

    formatoNumeroPorcentaje = (numeroDecimal) => {
        var numero = numeroDecimal.toFixed(2);
        var cadenaParteUno = "";
        var cadenaPartida = numero.toString().split(".");
        if (cadenaPartida[0].length === 1) {
            cadenaParteUno = "0" + cadenaPartida[0];
        }
        if (cadenaPartida[0].length === 2) {
            cadenaParteUno = cadenaPartida[0];
        }
        var cadenaFinal = cadenaParteUno + "." + cadenaPartida[1];
        console.log(cadenaFinal);
        return cadenaFinal;
    }

    formatoNumeroCuota = (numeroDecimal) => {
        var numero = numeroDecimal.toFixed(2);
        var cadenaParteUno = "";
        var cadenaPartida = numero.toString().split(".");
        if (cadenaPartida[0].length === 1) {
            cadenaParteUno = "0000" + cadenaPartida[0];
        }
        if (cadenaPartida[0].length === 2) {
            cadenaParteUno = "000" + cadenaPartida[0];
        }
        if (cadenaPartida[0].length === 3) {
            cadenaParteUno = "00" + cadenaPartida[0];
        }
        if (cadenaPartida[0].length === 4) {
            cadenaParteUno = "0" + cadenaPartida[0];
        }
        if (cadenaPartida[0].length === 5) {
            cadenaParteUno = cadenaPartida[0];
        }
        var cadenaFinal = cadenaParteUno + "." + cadenaPartida[1];
        console.log(cadenaFinal);
        return cadenaFinal;
    }

    formatoNumeroFactor = (numeroDecimal) => {
        var numero = numeroDecimal.toFixed(4);
        var cadenaParteUno = "";
        var cadenaPartida = numero.toString().split(".");
        if (cadenaPartida[0].length === 1) {
            cadenaParteUno = "00" + cadenaPartida[0];
        }
        if (cadenaPartida[0].length === 2) {
            cadenaParteUno = "0" + cadenaPartida[0];
        }
        if (cadenaPartida[0].length === 3) {
            cadenaParteUno = cadenaPartida[0];
        }
        var cadenaFinal = cadenaParteUno + "." + cadenaPartida[1];
        console.log(cadenaFinal);
        return cadenaFinal;
    }

    buscarCreditoReciente = () => {
        let { movimiento, trabajador } = this.state;
        let movimientoTrabajador = {};
        movimientoTrabajador.idTrabajador = trabajador.id;
        movimientoTrabajador.fecha = movimiento.fecha;
        servicioHttp.consumirPostHttp("trabajador_sua/credito_reciente.json", movimientoTrabajador).then(response => {
            let tipo = response.data.objeto;
            let tipoValor = response.data.objeto.valorDescuento;

            if (!response.data.error) {
                movimiento.tipoDescuento = tipo.tipoDescuento;

                if (movimiento.tipoDescuento === '1') {
                    movimiento.valorDescuento = this.formatoNumeroPorcentaje(tipoValor);
                    if (movimiento.valorDescuento === "20.00" || movimiento.valorDescuento === "25.00" || movimiento.valorDescuento === "30.00") {
                        this.setState({ aplicaDescuento: true });
                    } else {
                        this.setState({ aplicaDescuento: false });
                    }
                }
                if (movimiento.tipoDescuento === '2') {
                    movimiento.valorDescuento = this.formatoNumeroCuota(tipoValor)
                }
                if (movimiento.tipoDescuento === '3') {
                    movimiento.valorDescuento = this.formatoNumeroFactor(tipoValor)
                }

                movimiento.numCredito = tipo.numCredito;
                movimiento.vigencia = tipo.vigencia;
                this.setState({ movimiento });
            } else {
                this.growl.show({ severity: 'error', summary: 'Error', detail: response.data.mensaje });
            }
        }).catch(error => {
        });
    }

    render() {
        let { controlIncapacidades, secuelaConcecuencias, tipoRiesgos, ramoSeguros, mostrarModalActualizarIncapacidades, movimiento, errores, paginacion, tipoMovimientos, deshabilitado,
            mostrarCalendario, motivosDeBaja, mostrarBorrarTrabajador, tiposDescuentos, aplicaDescuento } = this.state;
        let propsNavegador = obtenerInformacionNavegador();
        let pieTablaExportar = <div className="p-fluid p-grid">
            <div className="p-col-12 p-md-2">
                {!servicioObjetos.esObjetoVacio(paginacion.datos) ? <Button className="p-button-secondary" type="button" onClick={this.generaReporteMovimientos} name="Reporte" label="Reporte" icon="pi-md-folder" tooltip="Reporte"></Button> : null}
            </div>
        </div>;

        let calendardioFechaInicio = <div>
            <Calendar onBlur={this.actualizarDiasFechaFinal} appendTo={document.body} id="movimiento.fecha" name="movimiento.fecha"
                value={movimiento.fecha || ''} onChange={(e) => this.asignarValores(e, false)}
                style={{ width: "100%" }} dateFormat={FORMATO_FECHA_CALENDAR}
                locale={CALENDARIO_ES_MX} disabled={deshabilitado.fecha}></Calendar>
            {errores.fecha ? <Message severity="error" text={errores.fecha} /> : null}
        </div>;


        let calendardioFechaFinalIncapacidad = <div>
            <Calendar appendTo={document.body} id="movimiento.fechaFinalIncapacidad" name="movimiento.fechaFinalIncapacidad"
                value={movimiento.fechaFinalIncapacidad || ''} onChange={(e) => this.asignarValores(e, false)}
                style={{ width: "100%" }} dateFormat={FORMATO_FECHA_CALENDAR}
                locale={CALENDARIO_ES_MX} disabled={true} ></Calendar>
            {errores.fechaFinalIncapacidad ? <Message severity="error" text={errores.fechaFinalIncapacidad} /> : null}
        </div>;

        const pieDialogoEliminar = (
            <div>
                <Button icon="pi-md-check" onClick={this.btnBorrarTrabajador} label="Si" />
                <Button icon="pi-md-close" onClick={this.cerrarModalEliminarTrabajador} label="No" className="p-button-danger flat-btn" />
            </div>
        );
        const pieDialogoIncapacidades = (
            <div>
                <Button icon="pi-md-check" label="Aceptar" onClick={this.guardarIncapacidad} />
                <Button icon="pi-md-close" label="Cancelar" onClick={this.cancelarIncidencia} className="p-button-danger flat-btn" />
            </div>
        );

        return (

            <div>
                <Growl ref={(el) => this.growl = el} />
                <div className="p-grid">
                    <div className="p-col-12 p-md-2">
                        <label htmlFor="movimiento.tipoMovimiento"><strong>MOVIMIENTO:</strong></label>
                    </div>
                    <div className="p-col-12 p-md-2">
                        <Dropdown appendTo={document.body} id="movimiento.tipoMovimiento" name="movimiento.tipoMovimiento"
                            value={movimiento.tipoMovimiento || ""} className={errores.tipoMovimiento ? "p-error" : ""}
                            options={tipoMovimientos} onChange={(e) => { this.asignarValores(e, false) }}
                            optionLabel="label" autoWidth={false} style={{ width: "100%" }} disabled={deshabilitado.tipoMovimiento} />
                        {errores.tipoMovimiento ? <Message severity="error" text={errores.tipoMovimiento} /> : null}
                    </div>

                    {movimiento.tipoMovimiento !== undefined && movimiento.tipoMovimiento.value === "16" ?
                        <div className="p-col-12 p-md-2">
                            <label htmlFor="movimiento.fechaSuspencion"><strong>FECHA SUSPENCIÓN:</strong></label>
                        </div>
                        :
                        <div className="p-col-12 p-md-2">
                            <label htmlFor="movimiento.tipoMovimiento"><strong>FECHA DE INICIO:</strong></label>
                        </div>
                    }
                    <div className="p-col-12 p-md-2">
                        {mostrarCalendario ? calendardioFechaInicio : null}
                    </div>
                    <div className="p-col-12 p-md-3">
                        <label></label>
                    </div>

                    <div className="p-col-12 p-md-2">
                        <label htmlFor="movimiento.sdi"><strong>S. D. I.:</strong></label>
                    </div>
                    <div className="p-col-12 p-md-2">
                        <InputText type="search" id="movimiento.sdi" name="movimiento.sdi"
                            value={movimiento.sdi || ""} className={errores.sdi ? "p-error" : ""}
                            onChange={(e) => { this.asignarValores(e, false) }} disabled={deshabilitado.sdi}
                            maxLength="7" keyfilter={DEFAULT_MASKS.money} />
                        {errores.sdi ? <Message severity="error" text={errores.sdi} /> : null}
                    </div>
                    <div className="p-col-12 p-md-8">
                        <label></label>
                    </div>

                    <div className="p-col-12 p-md-2">
                        <label htmlFor="movimiento.motivoBaja"><strong>MOTIVO DE BAJA:</strong></label>
                    </div>
                    <div className="p-col-12 p-md-2">
                        <Dropdown appendTo={document.body} id="movimiento.motivoBaja" name="movimiento.motivoBaja"
                            value={movimiento.motivoBaja || ""} className={errores.motivoBaja ? "p-error" : ""}
                            options={motivosDeBaja} onChange={(e) => { this.asignarValores(e, false) }}
                            optionLabel="label" autoWidth={false} style={{ width: "100%" }}
                            disabled={deshabilitado.motivoBaja} />
                        {errores.motivoBaja ? <Message severity="error" text={errores.motivoBaja} /> : null}
                    </div>

                    <div className="p-col-12 p-md-2">
                        <label htmlFor="movimiento.motivoBaja"><strong>FOLIO:</strong></label>
                    </div>
                    <div className="p-col-12 p-md-2">
                        <InputText type="search" id="movimiento.folio" name="movimiento.folio"
                            value={movimiento.folio || ""} className={errores.folio ? "p-error" : ""}
                            onChange={(e) => { this.asignarValores(e, false) }} disabled={deshabilitado.folio} />
                        {errores.folio ? <Message severity="error" text={errores.folio} /> : null}
                    </div>

                    <div className="p-col-12 p-md-2">
                        <label htmlFor="movimiento.dias"><strong>DÍAS:</strong></label>
                    </div>
                    <div className="p-col-12 p-md-2">
                        <InputText type="search" id="movimiento.dias" name="movimiento.dias"
                            value={movimiento.dias || ""} className={errores.dias ? "p-error" : ""}
                            onChange={(e) => { this.asignarValores(e, false) }} disabled={deshabilitado.dias}
                            maxLength="2" keyfilter="num"
                        />
                        {errores.dias ? <Message severity="error" text={errores.dias} /> : null}
                    </div>

                    <div className="p-col-12 p-md-2">
                        <label htmlFor="movimiento.tipoDescuento"><strong>TIPO DESCUENTO:</strong></label>
                    </div>
                    <div className="p-col-12 p-md-2">
                        <Dropdown appendTo={document.body} id="movimiento.tipoDescuento" name="movimiento.tipoDescuento"
                            value={movimiento.tipoDescuento || ""} className={errores.tipoDescuento ? "p-error" : ""}
                            options={tiposDescuentos} onChange={(e) => { this.asignarValores(e, false) }}
                            optionValue="value" autoWidth={false} style={{ width: "100%" }}
                            disabled={deshabilitado.tipoDescuento} />
                        {errores.tipoDescuento ? <Message severity="error" text={errores.tipoDescuento} /> : null}
                    </div>

                    <div className="p-col-12 p-md-2">
                        <label htmlFor="movimiento.valorDescuento"><strong>VALOR DESC.:</strong></label>
                    </div>

                    <div className="p-col-12 p-md-2">
                        <InputText type="number" id="movimiento.valorDescuento" name="movimiento.valorDescuento"
                            value={movimiento.valorDescuento || ""} className={errores.valorDescuento ? "p-error" : ""}
                            onChange={(e) => { this.asignarValores(e, false) }} disabled={deshabilitado.valorDescuento} maxLength="8" keyfilter="num"
                            style={{ width: "100%", 'font-weight': 'bold', color: 'black' }} />
                        {errores.valorDescuento ? <Message severity="error" text={errores.valorDescuento} /> : null}
                    </div>

                    <div className="p-col-12 p-md-2">
                        <label htmlFor="movimiento.numCredito"><strong>NUM. CRÉDITO:</strong></label>
                    </div>
                    <div className="p-col-12 p-md-2">
                        <InputText type="search" id="movimiento.numCredito" name="movimiento.numCredito"
                            value={movimiento.numCredito || ""} className={errores.numCredito ? "p-error" : ""}
                            onChange={(e) => { this.asignarValores(e, false) }} disabled={deshabilitado.numCredito} maxLength="10" keyfilter="pint"
                            style={{ width: "100%", 'font-weight': 'bold', color: 'black' }} />
                        {errores.numCredito ? <Message severity="error" text={errores.numCredito} /> : null}
                    </div>

                    <div className="p-col-12 p-md-6">
                        <label htmlFor="movimiento.aplicaDescuento"><strong>{aplicaDescuento ? 'APLICA TABLA DE DISMINUCIÓN %' : 'NO APLICA TABLA DE DISMINUCIÓN %'}</strong></label>
                        <Checkbox inputId="movimiento.aplicaDescuento" id="movimiento.aplicaDescuento" name="movimiento.aplicaDescuento" value={movimiento.aplicaDescuento}
                            disabled={deshabilitado.aplicaDescuento} checked={aplicaDescuento} onChange={e => this.setState({ aplicaDescuento: e.checked })} />
                        {errores.aplicaDescuento ? <Message severity="error" text={errores.aplicaDescuento} /> : null}
                    </div>
                    <div className="p-col-12 p-md-6">
                        <label></label>
                    </div>


                    <div className="p-col-12 p-md-2">
                        <label htmlFor="movimiento.articulo33"><strong>TRABAJADOR CON ART. 33:</strong></label>
                    </div>

                    {movimiento.tipoMovimiento !== undefined && movimiento.tipoMovimiento.value === "07" ?
                        <div className="p-col-12 p-md-2">
                            <TriStateCheckbox id="movimiento.articulo33" name="movimiento.articulo33" value={movimiento.articulo33} onChange={(e) => this.setValue(e.value)} disabled={true} />
                        </div>
                        : null}
                    <div className="p-col-12 p-md-2">
                        <label htmlFor="movimiento.salarioOtrosSeguros"><strong>SALARIOS OTROS SEGUROS:</strong></label>
                    </div>
                    <div className="p-col-12 p-md-2">
                        <InputText type="search" id="movimiento.salarioOtrosSeguros" name="movimiento.salarioOtrosSeguros"
                            value={movimiento.salarioOtrosSeguros || ""} className={errores.salarioOtrosSeguros ? "p-error" : ""}
                            onChange={(e) => { this.asignarValores(e, false) }} disabled={deshabilitado.salarioOtrosSeguros} />
                        {errores.salarioOtrosSeguros ? <Message severity="error" text={errores.salarioOtrosSeguros} /> : null}
                    </div>

                    <div className="p-col-12 p-md-2">
                        <label htmlFor="movimiento.salarioIvCv"><strong>SALARIO IV Y CV:</strong></label>
                    </div>
                    <div className="p-col-12 p-md-2">
                        <InputText type="search" id="movimiento.salarioIvCv" name="movimiento.salarioIvCv"
                            value={movimiento.salarioOtrosSeguros || ""} className={errores.salarioIvCv ? "p-error" : ""}
                            onChange={(e) => { this.asignarValores(e, false) }} disabled={deshabilitado.salarioIvCv} />
                        {errores.salarioIvCv ? <Message severity="error" text={errores.salarioIvCv} /> : null}
                    </div>
                </div>
                <DataTable ref={(el) => this.dt = el} footer={pieTablaExportar} value={paginacion.datos} selectionMode="single"
                    header="MOVIMIENTOS" responsive={true} resizableColumns={false} autoLayout={true} onRowDoubleClick={this.eliminarMovimientos}>
                    <Column body={this.formatearTipoMovimiento} header="MOVIMIENTO" />
                    <Column body={this.formatearColumnaFecha} header="FECHA DE INICIO" />
                    <Column field="sdi" header="S.D.I." />
                    <Column field="dias" header="DÍAS" />
                    <Column field="folio" header="FOLIO" />
                    <Column body={this.formatearRama} header="RAMA INC" />
                    <Column body={this.formatearTipoRiesgo} header="TIPO RGO." />
                    <Column body={this.formatearSecuencia} header="SECUELA" />
                    <Column body={this.formatearControl} header="CRTL INCAP" />
                    <Column body={this.formatearColumnaFechaTermino} header="FECHA TERM" />
                    <Column field="" header="PORC. INCAP." />
                    <Column body={this.formatearTipoDescuento} header="TIPO" />
                    <Column field="valorDescuento" header="VALOR" />
                    <Column field="numCredito" header="CRÉDITO" />
                    <Column field="vigencia" header="ESTATUS" />
                </DataTable>

                <Dialog style={{ width: propsNavegador.device.type === 'desktop' ? '60%' : '90%', height: '25%' }} appendTo={document.body} header="Actualizar Trabajadores" visible={mostrarBorrarTrabajador}
                    modal={true} onHide={this.cerrarModalEliminarTrabajador} footer={pieDialogoEliminar}>
                    <h2>¿Desea borrar el movimiento?</h2>
                </Dialog>
                <Dialog style={{ width: propsNavegador.device.type === 'desktop' ? '60%' : '90%', height: '55%' }} appendTo={document.body} header="Actualización de Incapacidades" visible={mostrarModalActualizarIncapacidades}
                    modal={true} onHide={this.cerrarModalActualizarIncapacidades} footer={pieDialogoIncapacidades}>
                    <div className="p-grid">
                        <div className="p-col-12 p-md-3">
                            <label htmlFor="movimiento.ramoSeguro"><strong>Ramo de Seguro:</strong></label>
                        </div>
                        <div className="p-col-12 p-md-3">
                            <Dropdown appendTo={document.body} id="movimiento.ramoSeguro" name="movimiento.ramoSeguro"
                                value={movimiento.ramoSeguro || ""} className={errores.ramoSeguro ? "p-error" : ""}
                                options={ramoSeguros} onChange={(e) => { this.asignarValores(e, false) }}
                                optionLabel="label" autoWidth={false} style={{ width: "100%" }} />
                            {errores.ramoSeguro ? <Message severity="error" text={errores.ramoSeguro} /> : null}
                        </div>
                        <div className="p-col-12 p-md-3">
                            <label htmlFor="movimiento.tipoRiesgo"><strong>Tipo de Riesgo:</strong></label>
                        </div>
                        <div className="p-col-12 p-md-3">
                            <Dropdown appendTo={document.body} id="movimiento.tipoRiesgo" name="movimiento.tipoRiesgo"
                                value={movimiento.tipoRiesgo || ""} className={errores.tipoRiesgo ? "p-error" : ""}
                                options={tipoRiesgos} onChange={(e) => { this.asignarValores(e, false) }}
                                optionLabel="label" autoWidth={false} style={{ width: "100%" }} disabled={deshabilitado.tipoRiesgo} />
                            {errores.tipoRiesgo ? <Message severity="error" text={errores.tipoRiesgo} /> : null}
                        </div>
                        <div className="p-col-12 p-md-3">
                            <label htmlFor="movimiento.secuelaOconcecuencia"><strong>Secuela o Concecuencias:</strong></label>
                        </div>
                        <div className="p-col-12 p-md-3">
                            <Dropdown appendTo={document.body} id="movimiento.secuelaOconcecuencia" name="movimiento.secuelaOconcecuencia"
                                value={movimiento.secuelaOconcecuencia || ""} className={errores.secuelaOconcecuencia ? "p-error" : ""}
                                options={secuelaConcecuencias} onChange={(e) => { this.asignarValores(e, false) }}
                                optionLabel="label" autoWidth={false} style={{ width: "100%" }} disabled={deshabilitado.secuelaOconcecuencia} />
                            {errores.secuelaOconcecuencia ? <Message severity="error" text={errores.secuelaOconcecuencia} /> : null}
                        </div>
                        <div className="p-col-12 p-md-3">
                            <label htmlFor="movimiento.controlIncapacidad"><strong>Control de la incapacidad:</strong></label>
                        </div>
                        <div className="p-col-12 p-md-3">
                            <Dropdown appendTo={document.body} id="movimiento.controlIncapacidad" name="movimiento.controlIncapacidad"
                                value={movimiento.controlIncapacidad || ""} className={errores.controlIncapacidad ? "p-error" : ""}
                                options={controlIncapacidades} onChange={(e) => { this.asignarValores(e, false) }}
                                optionLabel="label" autoWidth={false} style={{ width: "100%" }} disabled={deshabilitado.controlIncapacidad} />
                            {errores.controlIncapacidad ? <Message severity="error" text={errores.controlIncapacidad} /> : null}
                        </div>
                        <div className="p-col-12 p-md-3">
                            <label htmlFor="movimiento.fechaInicio"><strong>Fecha de Inicio:</strong></label>
                        </div>
                        <div className="p-col-12 p-md-3">
                            {mostrarCalendario ? calendardioFechaInicio : null}
                        </div>

                        <div className="p-col-12 p-md-3">
                            <label htmlFor="movimiento.fechaFinalIncapacidad"><strong>Fecha Final :</strong></label>
                        </div>

                        <div className="p-col-12 p-md-3">
                            {mostrarCalendario ? calendardioFechaFinalIncapacidad : null}
                        </div>
                        <div className="p-col-12 p-md-12">

                        </div>
                        <div className="p-col-12 p-md-2">
                            <label htmlFor="movimiento.folio"><strong>folio :</strong></label>
                        </div>
                        <div className="p-col-12 p-md-2">
                            <InputText type="text" id="movimiento.folio" name="movimiento.folio"
                                value={movimiento.folio || ""} className={errores.folio ? "p-error" : ""}
                                onChange={(e) => { this.asignarValores(e, false) }} disabled={deshabilitado.folio} />
                            {errores.folio ? <Message severity="error" text={errores.folio} /> : null}
                        </div>
                        <div className="p-col-12 p-md-2">
                            <label htmlFor="movimiento.dia"><strong>día :</strong></label>
                        </div>

                        <div className="p-col-12 p-md-2">
                            <InputText type="text" id="movimiento.dias" name="movimiento.dias"
                                value={movimiento.dias || ""} className={errores.dias ? "p-error" : ""}
                                onChange={(e) => { this.asignarValores(e, false) }} onBlur={this.sumarDiasFechaInicio} disabled={deshabilitado.dias} />
                            {errores.dias ? <Message severity="error" text={errores.dias} /> : null}
                        </div>
                        <div className="p-col-12 p-md-2">
                            <label htmlFor="movimiento.dia"><strong>Porcentaje :</strong></label>
                        </div>
                        <div className="p-col-12 p-md-2">
                            <InputText type="text" id="movimiento.porcentaje" name="movimiento.porcentaje"
                                value={movimiento.porcentaje || ""} className={errores.porcentaje ? "p-error" : ""}
                                onChange={(e) => { this.asignarValores(e, false) }} disabled={deshabilitado.porcentaje} />
                            {errores.porcentaje ? <Message severity="error" text={errores.porcentaje} /> : null}
                        </div>


                    </div>
                </Dialog>



            </div>
        );
    }

}